export type PasswordValidationResult = {
  valid: boolean;
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasDigit: boolean;
};

export function validatePassword(password: string): PasswordValidationResult {
  const hasMinLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const valid = hasMinLength && hasUppercase && hasLowercase && hasDigit;

  return { valid, hasMinLength, hasUppercase, hasLowercase, hasDigit };
}
